import { replaceParameters } from '@/common-utils/functions/restUtils';
import customizationFields from '../../fields/customizationFields';
import contractFields from '@/app/modules/contracts/fields/contractFields';

const { client } = require('@/common-utils/libraries/axios/axios');
const { default: CUSTOMIZATION } = require('../apiUrls');

/**
 * @param responseData response.data object
 * @param responseData.items array
 * @param responseData.totalResults number
 *
 * @param response
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {};

    data[customizationFields.UUID.key] = response[customizationFields.UUID.key];
    data[customizationFields.MERCHANT_UUID.key] = response[customizationFields.MERCHANT_UUID.key];
    data[customizationFields.IDENTIFIANT.key] = response[customizationFields.IDENTIFIANT.key];
    data[customizationFields.COLOR.key] = response[customizationFields.COLOR.key];
    data[customizationFields.LABEL.key] = response[customizationFields.LABEL.key];
    data[customizationFields.LOGO.key] = response[customizationFields.LOGO.key];
    data[customizationFields.LOCALE.key] = response[customizationFields.LOCALE.key];
    data[customizationFields.CREATED_AT.key] = response[customizationFields.CREATED_AT.key];
    data[customizationFields.MPF_OPTIONS.key] = response[customizationFields.MPF_OPTIONS.key].map(item => ({
        [customizationFields.MPF_OPTIONS.NAME.key]: item[customizationFields.MPF_OPTIONS.NAME.key],
        [customizationFields.MPF_OPTIONS.VALUE.key]: item[customizationFields.MPF_OPTIONS.VALUE.key]
    }));
    data[customizationFields.BENEFICIARIES.key] = response[customizationFields.BENEFICIARIES.key].map(item => ({
        [customizationFields.BENEFICIARIES.NAME.key]: item[customizationFields.BENEFICIARIES.NAME.key],
        [customizationFields.BENEFICIARIES.COLOR.key]: item[customizationFields.BENEFICIARIES.COLOR.key],
        [customizationFields.BENEFICIARIES.CONTRACTS.key]: item[customizationFields.BENEFICIARIES.CONTRACTS.key].map(contract => ({
            [contractFields.APPLICATION.key]: contract[contractFields.APPLICATION.key],
            [contractFields.BANK_CODE.key]: contract[contractFields.BANK_CODE.key],
            [contractFields.NUMBER.altKey]: contract[contractFields.NUMBER.altKey],
            [contractFields.CREATED_AT.key]: contract[contractFields.CREATED_AT.key],
            [contractFields.MERCHANT_LABEL.key]: contract[contractFields.MERCHANT_LABEL.key],
            [contractFields.MERCHANT_LEGAL_NAME.key]: contract[contractFields.MERCHANT_LEGAL_NAME.key],
            [contractFields.MERCHANT_NAME.key]: contract[contractFields.MERCHANT_NAME.key],
            [contractFields.RANK.key]: contract[contractFields.RANK.key],
            [contractFields.UPDATED_AT.key]: contract[contractFields.UPDATED_AT.key],
            [contractFields.UUID.key]: contract[contractFields.UUID.key]
        })),
        [customizationFields.BENEFICIARIES.CREATED_AT.key]: item[customizationFields.BENEFICIARIES.CREATED_AT.key],
        [customizationFields.BENEFICIARIES.UPDATED_AT.key]: item[customizationFields.BENEFICIARIES.UPDATED_AT.key],
        [customizationFields.BENEFICIARIES.UUID.key]: item[customizationFields.BENEFICIARIES.UUID.key]
    }));
    data[customizationFields.SCENARIOS.key] = response[customizationFields.SCENARIOS.key]?.map(scenario => ({
        [customizationFields.SCENARIOS.PACKAGE_NAME.key]: scenario[customizationFields.SCENARIOS.PACKAGE_NAME.key],
        [customizationFields.SCENARIOS.SCENARIO.key]: scenario[customizationFields.SCENARIOS.SCENARIO.key].map(setup => ({
            [customizationFields.SCENARIOS.SCENARIO.STEP_NAME.key]: setup[customizationFields.SCENARIOS.SCENARIO.STEP_NAME.key],
            [customizationFields.SCENARIOS.SCENARIO.PARAMS.key]: {
                [customizationFields.SCENARIOS.SCENARIO.PARAMS.INPUT_TYPE.key]:
                    setup[customizationFields.SCENARIOS.SCENARIO.PARAMS.key]?.[customizationFields.SCENARIOS.SCENARIO.PARAMS.INPUT_TYPE.key]
            }
        }))
    }));

    return data;
}

const queryGetCustomization = ({ customizationId }, enabled) => {
    return {
        queryKey: [CUSTOMIZATION.FETCH_PACKAGE_CUSTOMIZATION.queryKey, customizationId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(CUSTOMIZATION.FETCH_PACKAGE_CUSTOMIZATION.url, { packageId: customizationId }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetCustomization;